import React from "react";
import { F } from "../../../utils/gerencialFields";
import { formatarData } from "../../../utils/calculos";
import {
  CriticosTable,
  CriticosTableWrapper,
  CriticosTd,
  CriticosTh,
  EmptyHint,
  ToneText,
} from "./styles";

function formatarDataCorta(data) {
  if (!data) return "—";
  return formatarData(data);
}

function tomDaMargem(margem) {
  if (margem == null) return "neutral";
  if (margem < 0) return "danger";
  if (margem <= 3) return "warning";
  return "success";
}

export default function CordaTable({ proximas }) {
  if (!proximas || proximas.length === 0) {
    return (
      <EmptyHint>
        Sem ambientes em Compras com data de entrega prevista — nada para corda hoje.
      </EmptyHint>
    );
  }

  return (
    <CriticosTableWrapper>
      <CriticosTable>
        <thead>
          <tr>
            <CriticosTh>Pedido</CriticosTh>
            <CriticosTh>Cliente</CriticosTh>
            <CriticosTh>Ambiente</CriticosTh>
            <CriticosTh>Entrega prog.</CriticosTh>
            <CriticosTh>Liberar até</CriticosTh>
            <CriticosTh $right>Margem (du)</CriticosTh>
          </tr>
        </thead>
        <tbody>
          {proximas.map(({ amb, dataLimite, margem }, index) => {
            const entrega =
              amb?.[F.DATA_REPROGRAMADA] ||
              amb?.[F.ENTREGA_PREVISTA] ||
              null;
            const tone = tomDaMargem(margem);
            return (
              <tr
                key={`${amb?.[F.NUMERO_DO_PEDIDO] || "row"}-${amb?.[F.AMBIENTE] || index}`}
              >
                <CriticosTd>{amb?.[F.NUMERO_DO_PEDIDO] || "—"}</CriticosTd>
                <CriticosTd>{amb?.[F.NOME_DO_CLIENTE] || "—"}</CriticosTd>
                <CriticosTd>{amb?.[F.AMBIENTE] || "—"}</CriticosTd>
                <CriticosTd>{formatarDataCorta(entrega)}</CriticosTd>
                <CriticosTd>{formatarDataCorta(dataLimite)}</CriticosTd>
                <CriticosTd $right>
                  <ToneText $tone={tone}>
                    {margem != null ? margem : "—"}
                  </ToneText>
                </CriticosTd>
              </tr>
            );
          })}
        </tbody>
      </CriticosTable>
    </CriticosTableWrapper>
  );
}
